
<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";
import Safety from "@app/Safety/Views/Safety.vue";

useBackButton();

</script>

<template>

    <Safety />
    
</template>
